// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e8440b9","667":"d567cbc8"}[chunkId] + ".chunk.js";
};